
import { Component, Mixins, ActionButtonConfig, FormModalMixins } from "@/lib";
import DomesticSalesProfit from "@/store/modules/reportstatistics/domesticsalesprofit/entity";
@Component
export default class EditDomesticSalesProfit extends Mixins(FormModalMixins) {
  model = new DomesticSalesProfit();
  created() {
    Object.assign(this.config, { modelTitleL: "app.ExportProfit.ProfitRemark", labelWidth: 200, okAction: "reportstatistics/domesticsalesprofit/update" });
  }
  get record() {
    return this.$store.state.reportstatistics.domesticsalesprofit.editDomesticSalesProfit;
  }
}
